<div class="zy-modal">
    <div class="zy-modal-body">
        <i class="material-icons">clear</i>
        <ng-content></ng-content>
    </div>
  </div>
  <div class="zy-modal-background"></div>